ScoreTrekBattle.League = ScoreTrekBattle.League || {};
ScoreTrekBattle.League.Matchday = ScoreTrekBattle.League.Matchday || {};

// Aktionen eines Spieltags, die in mehr als einer Ansicht angeboten werden.
//
// Liste und Detailansicht zeigen dasselbe Kontextmenue — die Aktionen gehoeren
// deshalb weder in die eine noch in die andere. Adressiert wird ueber
// `data-matchday-id` am umgebenden Element, das beide Ansichten tragen.
//
// Nach einer Aenderung wird `matchday.updated` ausgeloest; welche Ansicht sich
// daraufhin auffrischt, entscheidet sie selbst.
ScoreTrekBattle.League.Matchday.Actions = (function() {
    var _this;

    function getMatchday(element) {
        let $item;

        $item = $(element).closest('[data-matchday-id]');

        return {
            $item: $item,
            id: $item.attr('data-matchday-id') || '',
            title: ($item.attr('data-matchday-title') || $item.find('.matchday-title').text())
                .replace(/\s+/g, ' ')
                .trim()
        };
    }

    function notifyUpdated(matchdayId) {
        ScoreTrekBattle.Event.trigger('matchday.updated', [matchdayId]);
    }

    function setVisibility(element, isPublic) {
        let matchday;

        matchday = getMatchday(element);

        if (matchday.id === '') {
            return;
        }

        chmDialog.confirm(__i18n(`dialog/confirm/${isPublic ? 'makePublic' : 'makePrivate'}/text`, {
            colorClass: 'color-blue',
            reference: matchday.title
        }, true), {
            title: __i18n(`dialog/confirm/${isPublic ? 'makePublic' : 'makePrivate'}/title`),
            buttonYes: __i18n('button/toggle'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            ScoreTrekBattle.View.loading('League.Matchday.Actions.setVisibility', true);

            Api.request('/battle/league/matchday/update', {
                matchday: {id: matchday.id, isPublic: isPublic}
            }).then(result => {
                if (!result || !result.done) {
                    return;
                }

                matchday.$item.attr('data-event-is-public', isPublic ? 'yes' : 'no');
                notifyUpdated(matchday.id);
            }).catch(error => {
                chmDialog.error(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('League.Matchday.Actions.setVisibility', false);
            });
        }).catch(ignore => {});
    }

    ScoreTrekBattle.Event.on('action.matchday.makePublic', function() {
        setVisibility(this, true);
    });

    ScoreTrekBattle.Event.on('action.matchday.makePrivate', function() {
        setVisibility(this, false);
    });

    ScoreTrekBattle.Event.on('action.matchday.duplicate', function() {
        let matchday;

        matchday = getMatchday(this);

        if (matchday.id === '') {
            return;
        }

        chmDialog.confirm(__i18n('dialog/confirm/clone/text', {
            colorClass: 'color-blue',
            reference: matchday.title
        }, true), {
            title: __i18n('dialog/confirm/clone/title'),
            buttonYes: __i18n('button/clone'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            ScoreTrekBattle.View.loading('League.Matchday.Actions.duplicate', true);

            Api.request('/battle/league/matchday/duplicate', {
                id: matchday.id
            }).then(result => {
                if (!result || !result.matchday) {
                    return;
                }

                // Die Kopie steht in der Liste direkt beim Original — dorthin
                // springen und einmal pulsieren lassen, damit sie auffaellt.
                ScoreTrekBattle.Event.trigger('matchday.created', [result.matchday, matchday.id]);
            }).catch(error => {
                chmDialog.error(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('League.Matchday.Actions.duplicate', false);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.matchday.delete', function() {
        let matchday, isDetails;

        matchday = getMatchday(this);

        if (matchday.id === '') {
            return;
        }

        isDetails = (matchday.$item.closest('.matchday-details').length > 0);

        chmDialog.confirm(__i18n('dialog/confirm/delete/text', {
            colorClass: 'color-blue',
            reference: matchday.title
        }, true), {
            title: __i18n('dialog/confirm/delete/title'),
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            ScoreTrekBattle.View.loading('League.Matchday.Actions.delete', true);

            Api.request('/battle/league/matchday/delete', {
                id: matchday.id
            }).then(() => {
                // Aus der Detailansicht heraus gibt es nichts mehr anzuzeigen.
                if (isDetails) {
                    ScoreTrekBattle.View.goto('/league/plan');
                    return;
                }

                notifyUpdated(matchday.id);
            }).catch(error => {
                chmDialog.error(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('League.Matchday.Actions.delete', false);
            });
        }).catch(ignore => {});
    });

    _this = {};

    return _this;
})();
